import {scrollIntoView, windowWidth} from './utils'

const tabs = {
    tabs: document.querySelectorAll('.jsTab') as NodeListOf<HTMLElement>, 
    conts: document.querySelectorAll('.jsTabsBody') as NodeListOf<HTMLElement>,   
    reviewLink: document.getElementById('reviewLink') as HTMLElement | undefined,
    reviewsScroll: document.getElementById('reviewsScroll') as HTMLElement | undefined,
    reviewScrollMob: document.getElementById('reviewScrollMob') as HTMLElement | undefined,
    init() {
       this.setTabs();
       this.resetTabs();
       this.goToLink()
    },
    goToLink(){
        if(this.reviewsScroll && this.reviewLink){
            this.reviewLink.addEventListener('click',()=>{      
                if(windowWidth >= 1024){
                    scrollIntoView(this.reviewsScroll!, 200)
                    this.reviewsScroll!.click()                  
                }else{
                    scrollIntoView(this.reviewScrollMob!, 200)
                    this.reviewScrollMob!.click()                
                }      
        
            })
        }   
    },
    resetTabs() {
        window.addEventListener('reset', () => {
            this.setTabs()
        })
    },
    
    setTabs() {
        this.tabs.forEach((item, index)=>{    
           
            item.addEventListener('click',()=>{
              
                this.tabs.forEach((item, index)=>{
                    item.classList.remove('activeClass');
                    this.conts[index].classList.remove('activeClass');
                });
                item.classList.add('activeClass');
                this.conts[index].classList.add('activeClass');

            });
        });
    },


}

export default tabs;